import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import {DiscoverClubHouseGetResponse} from "libs/apiClient";
import {DiscoverClubHouseDetail} from "features/discover/DiscoverClubHouseDetail";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";

export function DiscoverClubHousePage() {
    const { id } = useParams();

    useEffect(() => { setScrollBehavior() }, [])

    const { data: response, isLoading, error } = client.getDiscoverClubHouse.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverClubHouseDetail"] })

    if (error) {
        const code = error?.response.status;

        if (code === 404) {
            return (
                <div>
                    <NotFoundPage />
                </div>
            );
        }
    }

	const data: DiscoverClubHouseGetResponse = response?.data || {} as DiscoverClubHouseGetResponse;

	return (
        <div className="discover-container">
            <div className="pageHeading">
				{isLoading
					? <SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
					: <DiscoverBreadcrumbs items={[
						{
							label: 'Clubs',
							route: '/discover/club'
						},
						{
							label: data.name || 'club',
							note: data.id,
						},
					]} />
				}
            </div>
			{isLoading
				? <PlayerUserDetailSkeleton />
				: <DiscoverClubHouseDetail clubHouseData={data} />}
        </div>
    )
}
